export const userNavigationGroupTypes = {
    adminLinks: 'adminLinks',
    testerLinks: 'testerLinks',
    backerCenterLinks: 'backerCenterLinks',
    accountSettingsLinks: 'accountSettingsLinks',
    profileLinks: 'profileLinks',
    logoutLinks: 'logoutLinks',
    loginLinks: 'loginLinks',
};